
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/edit","xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#8d98aa"}},[_c('path',{attrs:{"d":"M12.5 18.959h-5c-2.309 0-3.872-.488-4.921-1.537S1.042 14.809 1.042 12.5v-5c0-2.308.488-3.872 1.537-4.921S5.192 1.042 7.5 1.042h1.667a.625.625 0 01.625.625.625.625 0 01-.625.625H7.5c-1.955 0-3.238.372-4.037 1.171S2.292 5.545 2.292 7.5v5c0 1.955.372 3.238 1.171 4.037s2.082 1.171 4.037 1.171h5c1.955 0 3.238-.372 4.037-1.171s1.171-2.082 1.171-4.037v-1.666a.625.625 0 011.25 0v1.667c0 2.309-.488 3.872-1.537 4.921s-2.612 1.537-4.921 1.537z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M15.415.832a3.608 3.608 0 012.51 1.242c1.659 1.659 1.659 3.341 0 5l-6.567 6.568-.007.007a2.924 2.924 0 01-1.446.72l-2.506.358a2.294 2.294 0 01-.313.022 1.815 1.815 0 01-1.4-.612 1.887 1.887 0 01-.408-1.536l.358-2.506a2.851 2.851 0 01.722-1.454l6.567-6.567a3.553 3.553 0 012.49-1.242zm-4.936 11.921l6.562-6.562a2.579 2.579 0 00.87-1.477 2.279 2.279 0 00-.87-1.755 2.453 2.453 0 00-1.625-.877 2.41 2.41 0 00-1.607.876L7.242 9.525a1.667 1.667 0 00-.373.744l-.359 2.513a.666.666 0 00.117.54.58.58 0 00.456.179 1.027 1.027 0 00.14-.01l2.505-.358a1.752 1.752 0 00.751-.38z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M16.542 8.2a.625.625 0 01-.171-.024 6.62 6.62 0 01-2.87-1.683 6.57 6.57 0 01-1.678-2.866.625.625 0 01.433-.771.625.625 0 01.771.433 5.364 5.364 0 003.685 3.684.625.625 0 01-.17 1.226z","opacity":".4"}})])])
          )
        }
      }
    